import React from 'react';

/**
 * Split Hero Section - Two column layout with text on left and image on right
 * Used for page headers like Allemansrätten
 */
export default function SplitHeroSection({ 
    title, 
    children, 
    imageSrc, 
    imageAlt = "Hero image"
}) {
    return (
        <section className="bg-offwhite w-full py-16 md:py-20 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 lg:gap-16">
                    {/* Left Column - Text Content */}
                    <div className="w-full md:w-1/2 flex flex-col  md:items-start md:text-left">
                        <h1 className="font-heading justify-center items-center text-center text-3xl sm:text-4xl md:text-5xl font-bold text-charcoal mb-6 leading-tight">
                            {title}
                        </h1>
                        <div className="font-body text-charcoal/80 text-base sm:text-lg leading-relaxed space-y-4">
                            {children}
                        </div>
                    </div>

                    {/* Right Column - Image */}
                    <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                        <div className="relative w-full max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
                            <img 
                                src={imageSrc} 
                                alt={imageAlt} 
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
